import React, { MouseEvent, ReactElement } from 'react';
import classNames from 'classnames';
import { Icon } from '../../../../../../../components/CiscoUi';
import styles from './index.module.css';
import { determineAriaLabel } from './utils/utils';

export type NodeEditButtonProps = {
  name: string;
  onClick?: VoidFunction;
  isCenterAligned?: boolean;
};

export const NodeEditButton = ({
  name,
  onClick,
  isCenterAligned,
}: NodeEditButtonProps): ReactElement => {
  if (onClick === undefined) return <></>;

  const handleOnClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    onClick();
  };

  return (
    <div
      className={classNames(styles.root, {
        [styles.isCenterAligned]: isCenterAligned,
      })}
      onClick={(event) => handleOnClick(event)}
      aria-label={determineAriaLabel(name)}
      role="button"
    >
      <Icon name="pencil" className={styles.icon} />
    </div>
  );
};
